/**
 * Shows its children only to signed-in wallets. Everyone else is asked to sign in first.
 *
 * This only shapes the interface: the API checks the session on every request.
 */

import { Wallet } from "lucide-react";
import { type ReactNode, useState } from "react";

import { useSession } from "../auth/session.js";
import { SignInDialog } from "./SignInDialog.js";
import { MessagePage, styles } from "./ui.js";

export function RequireWallet({ reason, children }: { reason: string; children: ReactNode }) {
  const session = useSession();
  const [dialogOpen, setDialogOpen] = useState(false);

  if (session.isPending) {
    return null;
  }
  if (session.data) {
    return children;
  }
  return (
    <MessagePage
      icon={Wallet}
      title="Sign in to continue"
      actions={
        <button type="button" onClick={() => setDialogOpen(true)} className={styles.primaryButton}>
          Sign in
        </button>
      }
    >
      <p>{reason}</p>
      <p className="mt-2 text-sm">
        New to wallets? Signing in with a Base Account creates one with a passkey, without an app or
        extension.
      </p>
      <SignInDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </MessagePage>
  );
}
